var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._b({staticClass:"mb-1",attrs:{"color":_vm.logo ? '' : 'primary',"size":_vm.size}},'v-avatar',_vm.$attrs,false),[(_vm.logo)?_c('img',{staticClass:"cursor-pointer",attrs:{"src":_vm.logo}}):_c('span',{staticClass:"white--text font-weight-bold"},[_vm._v(_vm._s(_vm.logoName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }